import { render, staticRenderFns } from "./KidsProductPrices.vue?vue&type=template&id=1a472cd3&"
import script from "./KidsProductPrices.vue?vue&type=script&lang=js&"
export * from "./KidsProductPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports